import { useState } from "react"
import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog"
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select"

type EditableEmployee = {
  id: string
  name: string
  role: string
  department: string
  hourlyRate: number
  status: string
}

export function EditEmployeeDialog({
  employee,
  onOpenChange,
  open,
}: {
  employee: EditableEmployee
  onOpenChange: (open: boolean) => void
  open: boolean
}) {
  const [form, setForm] = useState({
    department: employee.department,
    hourlyRate: String(employee.hourlyRate),
    name: employee.name,
    role: employee.role,
    status: employee.status,
  })

  function handleSubmit() {
    router.patch(`/employees/${employee.id}`, {
      name: form.name,
      role: form.role,
      department: form.department,
      hourly_rate: form.hourlyRate,
      status: form.status,
    }, {
      onSuccess: () => onOpenChange(false),
    })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit employee</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <Label htmlFor="edit-emp-name">Name</Label>
            <Input id="edit-emp-name" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="Jane Smith" />
          </div>
          <div className="flex flex-col gap-1">
            <Label htmlFor="edit-emp-role">Role</Label>
            <Input id="edit-emp-role" value={form.role} onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))} placeholder="Electrician" />
          </div>
          <div className="flex flex-col gap-1">
            <Label htmlFor="edit-emp-dept">Department</Label>
            <Input id="edit-emp-dept" value={form.department} onChange={(e) => setForm((f) => ({ ...f, department: e.target.value }))} placeholder="Operations" />
          </div>
          <div className="flex flex-col gap-1">
            <Label htmlFor="edit-emp-rate">Hourly rate ($)</Label>
            <Input id="edit-emp-rate" type="number" min="0" step="0.01" value={form.hourlyRate} onChange={(e) => setForm((f) => ({ ...f, hourlyRate: e.target.value }))} placeholder="45.00" />
          </div>
          <div className="flex flex-col gap-1">
            <Label htmlFor="edit-emp-status">Status</Label>
            <Select value={form.status} onValueChange={(v) => setForm((f) => ({ ...f, status: v }))}>
              <SelectTrigger id="edit-emp-status">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="active">Active</SelectItem>
                <SelectItem value="on_leave">On leave</SelectItem>
                <SelectItem value="completed">Completed</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button size="sm" onClick={handleSubmit} disabled={!form.name || !form.role || !form.hourlyRate}>
            Save changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
